import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import G04docuGTestManagement from '../../G04docuGTest/G04docuGTestManagement';
import { getDivisionLabel } from '../../../utils/divisionUtils';

const SubstituteDocumentDialog = ({
  open,
  onClose,
  row,
  onDocumentSelected,
  gprojectId // GProject ID 추가
}) => {
  if (!row) return null;
  console.log(row)
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle>
        <Typography variant="h6">
          대체성적서 찾기
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {/* {row.company} - {row.productName} ({row.divisionLabel || getDivisionLabel(row.division)}) */}
          {row.company} - {row.productName}
        </Typography>
      </DialogTitle>
      
      <DialogContent sx={{ p: 0, flex: 1 }}>
        <Box sx={{ height: '100%' }}>
          <G04docuGTestManagement
            title="대체성적서"
            from={{
              source: "SubstituteDocumentDialog",
              params: {
                name: row.name,
                code: row.code,
                gclientId: row.gclientId,
                division: row.division,
                itemOrCertificationName: row.division === 'RAW_MATERIAL' ? row.gcomponentItemName : row.g04docuGCertificationName,
                gprojectId: gprojectId,
                onDocumentSelected,
              }
            }}
          />
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubstituteDocumentDialog; 